import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { styled, Tab, Tabs } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`
}));

interface Props {
  tab?: string
}

const AdminTabs: FC<Props> = ({ tab }) => {
  const { t } = useTranslation('registrations');
  const navigate = useNavigate();
  const [value, setValue] = useState(tab);

  const handleChange = (_: any, newValue: string) => {
    handleSwitchPage(newValue);
  };

  const handleSwitchPage = (goToTab: string) => {
    navigate(`/admin/${goToTab}`);
    setValue(goToTab);
  };

  return (
    <>
      <StyledTabs variant="fullWidth" style={{ marginBottom: '20px' }} value={value} onChange={handleChange} aria-label="admin tabs">
        <Tab
          value={'registrations'}
          icon={<FormatListBulletedIcon />}
          iconPosition={'start'}
          label={t('registrations.admin.registrations')}
        />
        <Tab
          value={'partners'}
          icon={<AccountCircleOutlinedIcon />}
          iconPosition={'start'}
          label={t('registrations.admin.partners')}
        />
      </StyledTabs>
    </>
  );
};

export default AdminTabs;
